export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';

export const GET_RELOCATION_CONSULTANTS_REQUEST = 'GET_RELOCATION_CONSULTANTS_REQUEST';
export const GET_RELOCATION_CONSULTANTS_SUCCESS = 'GET_RELOCATION_CONSULTANTS_SUCCESS';
export const GET_RELOCATION_CONSULTANTS_FAILURE = 'GET_RELOCATION_CONSULTANTS_FAILURE';
